import { render, staticRenderFns } from "./SidebarCard.vue?vue&type=template&id=55a18c81&"
import script from "./SidebarCard.vue?vue&type=script&lang=js&"
export * from "./SidebarCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports